<template>
  <div class="chat-conversations" id="conversationContainer">
    <div class="chat-conversations-header">
      <ConversationsSearch v-model="searchText" />
    </div>

    <ConversationsLoading v-if="isLoading" />

    <div class="chat-conversations-list">
      <div v-for="conversation in filteredConversations" :key="conversation.conversationId"
      class="chat-conversations-list-item"
        if="conversation.conversationId === selectedConversationId"
        :class="{ 'chat-conversation-selected': conversation.conversationId === selectedConversationId }"
        @click="handleConversationClick(conversation)"
        >
        <div class="chat-conversations-list-item-avatar">
          <img :src="getAvatar(conversation.photo)" alt="avatar" />
        </div>
        <div class="chat-conversations-list-item-info">
          <div class="chat-conversations-list-item-info-conversationid">
            {{ conversation.protocol }}
          </div>
          <div class="chat-conversations-list-item-info-name">
            <div :title="getDisplayName(conversation)">{{ getDisplayName(conversation) }}</div>
          </div>
          <div class="chat-conversations-list-item-info-message">
            {{ conversation.lastMessage == null
              ? ''
              : conversation.lastMessage.type == 'text'
                ? conversation.lastMessage.text
                : conversation.lastMessage.type == 'image'
                  ? 'Imagem'
                  : conversation.lastMessage.type == 'ptt'
                    ? 'Áudio'
                    : conversation.lastMessage.type == 'list'
                      ? 'Lista'
                      : conversation.lastMessage.type == 'document'
                        ? 'Documento'
                        : conversation.lastMessage.type == 'video'
                          ? 'Vídeo'
                          : ''
            }}
          </div>
        </div>
        <div class="chat-conversations-list-item-identify">
          <div class="chat-conversations-list-item-identify-provider">
          <img :src="`static/img/chat/providers/${conversation.provider}.png`" width="15px" alt="provider" />
        </div>
        <div class="chat-conversations-list-item-identify-countNotReads" v-if="conversation.unreaded > 0">
          {{ conversation.unreaded }}
        </div>
        </div>
      </div>
    </div>
        <b-button
            class="btn btn-sm btn-third rounded-4"
            size="sm"
            @click="openNewConversationModal"
          >
            <i class="fas fa-user-plus"></i>
            <span class="d-md-down-none">&nbsp; Iniciar nova conversa</span>
          </b-button>
    <NewConversationModal ref="newConversationModal" @createNewConversation="getNewConversation" />
  </div>
</template>

<script>
import ConversationsLoading from './ConversationsLoading.vue'
import ConversationsSearch from './ConversationsSearch.vue'
import ConversationsTabs from './ConversationsTabs.vue'
import AccountMixin from '@/store/module/account/mixin'
import NewConversationModal from '../modal/NewConversationModal.vue'
import {toast} from '@/shared/utils/UIHelper'

export default {
  name: 'Messages',
  components: {
    ConversationsSearch,
    ConversationsLoading,
    ConversationsTabs,
    NewConversationModal
  },
  mixins: [AccountMixin],
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    conversations: {
      type: Array,
      required: true
    },
    selectedConversationId: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      tabs: {
        active: 'Aberto',
        items: [
          {
            value: 'Aberto'
          },
          {
            value: 'Finalizado'
          }
        ]
      },
      searchText: '',
      timer: null,
      showModalNewConversation: false,
      newConversationMessage: '',
      newConversationSubject: '',
      newConversationPerson: '',
      paramConversationId: ''
    }
  },
  computed: {
    filteredConversations () {
      return this.conversations.filter(conversation => {
        return conversation.botId === 'NDA' && (conversation.name.nome.toLowerCase().includes(this.searchText.toLowerCase()) || conversation.conversationId.toString().toLowerCase().includes(this.searchText.toLowerCase()) || conversation.identifier.toString().toLowerCase().includes(this.searchText.toLowerCase().replace(/\D/g, '')) || conversation.protocol.toString().toLowerCase().includes(this.searchText.toLowerCase().replace(/\D/g, '')))
      })
    }
  },
  mounted () {
  },
  watch: {
    'tabs.active' (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('changeTab', newValue)
      }
    },
    filteredConversations: {
      handler () {
        const url = window.location.href

        const urlParams = new URLSearchParams(new URL(url).search)
        if (this.selectedConversationId === null && urlParams.get('conversationId') !== null) {
          const conversationId = urlParams.get('conversationId')
          const conversation = this.filteredConversations.find(c => c.conversationId === conversationId)
          if (conversation && this.selectedConversationId !== conversationId) {
            this.handleConversationClick(conversation)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    handleConversationClick (conversation) {
      this.$router.push({ query: { conversationId: conversation.conversationId } })
      this.$emit('selectConversation', conversation)
    },
    getDisplayName (conversation) {
      let name = 'Usuário não possui nome'
      if (conversation.name.nome) {
        name = conversation.name.nome
      }
      return name
    },
    getOrigemDisplayName (conversation) {
      let origem = conversation.name.origem
      if (origem === 'Conversa') {
        return 'Esse nome é de uma conversa'
      } else if (origem === 'Campanha') {
        return 'Esse nome é de uma campanha'
      } else if (origem === 'Pessoa') {
        return 'Esse nome é de um associado'
      } else {
        return 'Nome não registrado'
      }
    },
    openNewConversationModal () {
      this.$refs.newConversationModal.openModal()
    },
    getNewConversation (valores) {
      this.$refs.newConversationModal.closeModal()
      if (valores.existing) {
        toast.error(`Já existe uma conversa aberta e em atendimento para esse número, o atendente é ${valores.nameOperator}`, 'Erro')
      }
      this.$emit('createNewConversation', valores)
    },
    getAvatar (encodedImage) {
      if (encodedImage) {
        return `data:image/png;base64,${encodedImage}`
      }

      return '/static/img/avatars/03.png'
    }
  }
}
</script>
<style lang="scss">
#conversationContainer{

  .createNewConversation {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .createNewConversation span:hover {
    color: #04a791;
  }

  /* .createNewConversation {
    position: flex;
    bottom: 20px;
    right: 20px;
    background-color: #04a791;
    color: white;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
    margin-top: 10px;
  };

  .createNewConversation i {
    color: white;
  }
  .createNewConversation a {
    color: white;
  }
  .createNewConversation a:hover {
    color: white;
  } */
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/conversations/Conversations.vue